export default "/images/b1a690ce251613d253cb024fbc2aa619.avif";